module.exports = __webpack_public_path__ + "img/page.3a667a2a.png";